import script from "./SongReg2.vue?vue&type=script&setup=true&lang=js"
export * from "./SongReg2.vue?vue&type=script&setup=true&lang=js"

import "./SongReg2.vue?vue&type=style&index=0&id=071f2872&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071f2872"]])

export default __exports__